import styled from 'styled-components';

const Guide = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 1.5rem 0.5rem;
  margin: 0;
  width: 100%;
  height: 100%;
`;

export default Guide;
